import { render, staticRenderFns } from "./RelatedLetters.vue?vue&type=template&id=8b5a3ab4"
import script from "./RelatedLetters.vue?vue&type=script&lang=js"
export * from "./RelatedLetters.vue?vue&type=script&lang=js"
import style0 from "./RelatedLetters.vue?vue&type=style&index=0&id=8b5a3ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports